<template>
    <div>
        <p>
            Click on a participating state below to see the contact information of the state Go NAPSACC representative.
        </p>
        <div role="tablist" class="accordion-group">
            <template v-for="state in participatingStates" :key="state.abbrev">
                <div class="card m-2">
                    <base-collapse :id="state.abbrev" role="tabpanel" accordion="my-accordion">
                        <template v-slot:trigger>
                            <button class="btn btn-primary btn-block yanone state-name" variant="primary">
                                <span class="float-right when-opened">
                                    <i class="fas fa-angle-down"></i>
                                </span>
                                <span class="float-right when-closed">
                                    <i class="fas fa-angle-right"></i>
                                </span>
                                <span class="label">
                                    {{ state.name }}
                                </span>
                            </button>
                        </template>
                        <template v-slot:collapsed-content>
                            <div class="card-body rounded">
                                <div class="card-text">
                                    <div class="contact-name yanone">
                                        {{ state.contact }}
                                    </div>
                                    <div class="organization quatro">
                                        {{ state.organization }}
                                    </div>
                                    <div class="email quatro">
                                        <a :href="'mailto:'+ state.email ">{{ state.email }}</a>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </base-collapse>
                </div>
            </template>
        </div>
    </div>
</template>


<style scoped>
p {
    padding-left: 1em;
    padding-right: 1em;
}
li {
    color: #223264;
}
.accordion-group {
    margin-left: .5em;
    margin-right: .5em;
}
.yanone {
    font-family: 'Yanone Kaffeesatz', sans-serif;
}
.quatro {
    font-family: 'Quattrocento Sans', sans-serif;
}
div.card {
    padding: 0px;
}
.card-header {
    padding: 0px;
    border-bottom: 0;
}
#participating_states a.state-name {
    color: #fff;
    font-size: 1.5em;
    font-weight: 300;
    border: none;
}
#participating_states a.state-name:hover {
    color: #fff;
    background-color: #dc6a2f;
    outline: none;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
}
.btn {
    text-align: left;
}
.btn-primary:not(:disabled):not(.disabled):active, 
.btn-primary:not(:disabled):not(.disabled).active, 
.show > .btn-primary.dropdown-toggle {
    border-color: #dc6a2f;
    background-color: #dc6a2f;
}
.card-body {
    border: 2px solid #dc6a2f;
    margin-top: -6px;
}
.btn:focus, .btn:active {
    outline: none;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
}
.contact-name {
    color: #4d8ab7;
    font-size: 1.5em;
}
.organization {
    color: #223264;
    font-weight: lighter;
}
#participating_states .accordion-group .email a {
    color: #dc6a2f;
    word-wrap: break-word;
    font-size: .9em;
}
.trigger.collapsed .when-opened,
.trigger:not(.collapsed) .when-closed {
  display: none;
}

#participating_states a.state-name:not(.collapsed) {
    background-color: #dc6a2f;
}


</style>


<script>
    import BaseCollapse from '../BaseCollapse.vue';

    export default {
        components: {
            BaseCollapse
        },
        data() {
            return {
                participatingStates: []
            }
        },
        methods: {
            getParticipatingStates() {
                window.axios.get('/api/participating-states')
                    .then(response => {
                        this.participatingStates = response.data.data
                    });
            }
        },
        mounted() {
            this.getParticipatingStates();
        }
    }
</script>